var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { AsConfigService } from 'ngx-advanced-searchbox';
import { switchMap, map, catchError } from "rxjs/operators";
var AppConfigService = /** @class */ (function (_super) {
    __extends(AppConfigService, _super);
    function AppConfigService(_http) {
        var _this = _super.call(this, _http) || this;
        _this.customDomainsAsyncFn['youtube'] = function (observable, viewModel, model) {
            return observable.pipe(switchMap(function (term) {
                return _http.get('https://www.googleapis.com/youtube/v3/search', { params: {
                        q: term,
                        key: 'AIzaSyBafKFrisguQvT3WC20Q972uxS1cZfPvg8',
                        type: 'video',
                        maxResults: '12',
                        part: 'id,snippet'
                    } }).pipe(catchError(function () { return []; }), map(function (response) {
                    var newResponse = { response: [], term: '' };
                    newResponse.response = response.items.map(function (item) {
                        return { label: item.snippet.title };
                    });
                    newResponse.term = term;
                    return newResponse;
                }));
            }));
        };
        _this.customSuggestionsAsyncFn['gmap'] = _this.customDomainsAsyncFn['youtube'];
        _this.formatModelValue = {
            'youtube': function (val) {
                if (val) {
                    return val.label;
                }
                return val;
            },
            'birth.to': function (val) {
                var newVal = Object.assign({}, val);
                var daySplitted = val.value.split('-');
                newVal.value = new Date(parseInt(daySplitted[2]), parseInt(daySplitted[1]) - 1, parseInt(daySplitted[0]), 12);
                return newVal;
            },
            'birth.from': function (val) {
                var newVal = Object.assign({}, val);
                var daySplitted = val.value.split('-');
                newVal.value = new Date(parseInt(daySplitted[2]), parseInt(daySplitted[1]) - 1, parseInt(daySplitted[0]), 12);
                return newVal;
            },
            'city': function (val) {
                if (val) {
                    return val.value;
                }
                return val;
            }
        };
        _this.formatModelViewValue = {
            'youtube': function (val) {
                if (typeof val === 'string') {
                    return { label: val };
                }
                return val;
            },
            'birth.to': function (val) {
                var newVal = Object.assign({}, val);
                newVal.value = new Date(val.value);
                newVal.value = newVal.value.getDate() + "-" + (newVal.value.getMonth() + 1) + "-" + newVal.value.getFullYear();
                return newVal;
            },
            'birth.from': function (val) {
                var newVal = Object.assign({}, val);
                newVal.value = new Date(val.value);
                newVal.value = newVal.value.getDate() + "-" + (newVal.value.getMonth() + 1) + "-" + newVal.value.getFullYear();
                return newVal;
            },
            'city': function (val, template) {
                var domainsFiltered = template.domains.filter(function (par) {
                    return par.value == val;
                });
                if (domainsFiltered.length > 0) {
                    return domainsFiltered[0];
                }
                return val;
            },
            'test': function (val, template) {
                var domainsFiltered = template.domains.filter(function (par) {
                    return par.label == val.value;
                });
                if (domainsFiltered.length > 0) {
                    return domainsFiltered[0].value.id;
                }
                if (val.value) {
                    return val.value;
                }
                return val;
            }
        };
        _this.customDomainsModelFormatter = {
            'test': function (viewModel, val) {
                var current = viewModel.domains.filter(function (item) {
                    if (typeof val === 'object') {
                        return item.id == val.id;
                    }
                    return item.id == val;
                });
                return current[0].label;
            }
        };
        return _this;
    }
    return AppConfigService;
}(AsConfigService));
export { AppConfigService };
